import { useState, useEffect } from 'react';

const useResponsive = (): boolean => {
    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth < 768);
    const handleResize = (): void => {
        setIsMobile(window.innerWidth < 768);
    };

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return isMobile;
};

export default useResponsive;
